export function getLastPageNumber(listWrapperRootElement: HTMLElement): number {
    const totalPagesElement = listWrapperRootElement.querySelector('.js_cr_list-wrapper__pagination-last-page');
    if (!totalPagesElement) return 1;
    const totalPagesTextContent = totalPagesElement.textContent;
    if (!totalPagesTextContent) return 1;
    const parsedTextContent = parseInt(totalPagesTextContent);
    return isNaN(parsedTextContent) ? 1 : parsedTextContent;
}
